import Navigation1 from "../components/Navigation1";
import ButtonLearnMore from "../components/ButtonLearnMore";
import FramedownloadApp from "../components/FramedownloadApp";
import Cardqrdownloadapp from "../components/Cardqrdownloadapp";
import DivcolMd7 from "../components/DivcolMd7";
import DivcolMd3 from "../components/DivcolMd3";
import "./WwwmontyesimcomByHtmltod61.css";
import CountryFlags from "../components/CountryFlags";
import { useNavigate , Link } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import {
  FaSquareFacebook,
  FaSquareInstagram,
  FaSquareYoutube,
  FaTiktok,
  FaSquarePinterest
} from "react-icons/fa6";

const WwwmontyesimcomByHtmltod6 = () => {

  const navigate = useNavigate();
  return (
    <div className="wwwmontyesimcom-by-htmltod7">
      <Navigation1 />
      <section className="logo-container">
        <ButtonLearnMore />
      </section>
      <form className="picture">
        <div className="picture1">
          <div className="picture2">
            <b className="here-are-some">Here are some of our bestsellers</b>
          </div>
          <h1 className="heading-1-container">
            <p className="travel-carefree-with">Travel carefree with</p>
            <p className="monty-esim3">Trend eSIM!</p>
          </h1>
        </div>
        <CountryFlags isHome={true} />
        <div className="label">
          <div className="e-s-i-minfo">
            <div className="heading">
              <div className="learnmorebtn">
                <img
                  className="image-1-icon"
                  loading="eager"
                  alt=""
                  src="/image-1@2x.png"
                />
              </div>
              <div className="divcard14">
                <div className="qr-circles">
                  <div className="image">
                    <img className="arrowicond4caedd4svg" alt="" />
                    <div className="contactus">
                      <b className="easy-and-fast">Easy and fast</b>
                      <h1 className="heading-1-container1">
                        <p className="unlock-endless">Unlock endless</p>
                        <p className="benefits">benefits</p>
                      </h1>
                    </div>
                  </div>
                  <div className="sendmessagebtn">
                    <FramedownloadApp
                      easyIconf11bd8cdsvg="/easyiconf11bd8cdsvg.svg"
                      easyToAcquire="Easy to acquire"
                      acquiringAnESIMIsOftenEas="Acquiring an eSIM is often easier and faster than getting a traditional SIM card. Plus,"
                      theSwitchToESIMCanBeDoneO="the switch to eSIM can be done online, in minutes with only a few taps."
                    />
                    <FramedownloadApp
                      easyIconf11bd8cdsvg="/travelicon1eb8c12dsvg@2x.png"
                      easyToAcquire="Travel hassle-free"
                      acquiringAnESIMIsOftenEas="You no longer have to worry about waiting in lines at airports or visiting a store to"
                      theSwitchToESIMCanBeDoneO="get your own sim card. The eSIM is a real time saver!"
                      propAlignSelf="unset"
                      propFlex="unset"
                      propMinWidth="unset"
                    />
                    <FramedownloadApp
                      easyIconf11bd8cdsvg="/moneyicone283b833svg@2x.png"
                      easyToAcquire="A money saver"
                      acquiringAnESIMIsOftenEas="In addition to making your trip easier, eSIM will spare you excessive data charges."
                      theSwitchToESIMCanBeDoneO="With Trend eSIM, you get to browse the best bundles at the most affordable prices!"
                      propAlignSelf="stretch"
                      propFlex="1"
                      propMinWidth="430px"
                    />
                    <FramedownloadApp
                      easyIconf11bd8cdsvg="/planeticonfb57d036svg.svg"
                      easyToAcquire="You get to save the planet"
                      acquiringAnESIMIsOftenEas="This virtual tool reduces CO2 emissions and plastic waste helping the planet"
                      theSwitchToESIMCanBeDoneO="breathe again."
                      propAlignSelf="unset"
                      propFlex="unset"
                      propMinWidth="unset"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="montye-s-i-mlogo">
          <div className="header-montye-s-i-m">
            <b className="monty-esim4">Trend eSIM</b>
            <div className="subheading-travelhasslefree">
              <h1 className="heading-14">How to set up your eSIM?</h1>
              <div className="whether-youre-an">
                Whether you’re an iPhone or an Android user, here’s how it works
              </div>
            </div>
            <button className="button9" onClick={() => {
              navigate("/how-it-works")
            }}>
              <b className="learn-more">Learn more</b>
            </button>
          </div>
          <img
            className="user-guide-img4b7986e5jpg-icon"
            loading="eager"
            alt=""
            src="/userguideimg4b7986e5jpg@2x.png"
          />
        </div>
        <Cardqrdownloadapp />
        <DivcolMd7 />
      </form>
      <footer className="footer-phone-email">
        <div className="divfooter1">
          <div className="divcol-md-4">
            <img
              className="divfooter-section-icon"
              loading="eager"
              alt=""
              src="/divfootersectionicon5.svg"
            />
            <b className="phone">Phone</b>
            <b className="link-44">+44 7482 774201</b>
          </div>
          <div className="divcol-md-41">
            <img
              className="divfooter-section-icon1"
              alt=""
              src="/divfootersectionicon-13.svg"
            />
            <b className="email1">Email</b>
            <b className="link-supportmontyesimcom">support@trendesim.com</b>
          </div>
          <DivcolMd3
            divfooterSectionIcon="/divfootersectionicon-22.svg"
            propWidth="603.3px"
            propPadding="0px var(--padding-xl) var(--padding-mid)"
            propDisplay="flex"
            propWidth1="72px"
          />
        </div>
        <div className="divfooter-sub3">
          <div className="qr-curves-b-s-v-g">
            <Link style={{
              textDecoration: "none",
              color: "inherit"
            }}
              to="/privacy-policy"
            > <b >Privacy Policy</b></Link>
            <Link style={{
              textDecoration: "none",
              color: "inherit"
            }}
              to="/refund-policy"
            > <b >Refund Policy</b></Link>
            <Link style={{
              textDecoration: "none",
              color: "inherit"
            }}
              to="/term-condition"
            > <b >Terms & Conditions</b></Link>


            <div className="social-media">
              <b >Contact Us</b>

              <a href="https://www.facebook.com/people/Trendesim-English/61558743480892/" className="icon-links" target="_blank" rel="noopener noreferrer">
                <FaSquareFacebook />
              </a>
              <a href="https://www.instagram.com/trendesim/" className="icon-links" target="_blank" rel="noopener noreferrer">
                <FaSquareInstagram />
              </a>
              <a href="https://www.youtube.com/@TrendeSIM" className="icon-links" target="_blank" rel="noopener noreferrer">
                <FaSquareYoutube />
              </a>
              <a href="https://www.tiktok.com/@trendesim" className="icon-links" target="_blank" rel="noopener noreferrer">
                <FaTiktok />
              </a>
              <a href="https://www.pinterest.com/trendesim/" className="icon-links" target="_blank" rel="noopener noreferrer">
                <FaSquarePinterest />
              </a>

            </div>
          </div>
          <b>© 2024 Trend eSIM</b>
        </div>
      </footer>
      <Toaster />
    </div>
  );
};

export default WwwmontyesimcomByHtmltod6;
